import React from 'react';
import Icon from 'flow/components/ui-components/Icon';
import Tooltip from 'flow/components/ui-components/Tooltip';
import useAppContext from 'flow/hooks/useAppContext';
import LabelPlate, { plateIconSize } from './LabelPlate';

interface RestartVideoPlateProps {
    isCompact?: boolean;
    onRestart: () => void;
}

/**
 * Warning plate shown after repeated peer-setup failures; clicking it restarts
 * the participant's video connection.
 */
const RestartVideoPlate: React.FC<RestartVideoPlateProps> = ({
    isCompact = false,
    onRestart,
}) => {
    const { i18next } = useAppContext();

    return (
        <Tooltip
            className="z-2 bg-gray-600 p-3 text-sm text-white"
            label={i18next.t('videoconference.error.participant_no_video')}
            placement="top"
        >
            <LabelPlate
                isCompact={isCompact}
                className="z-2 shrink-0 cursor-pointer"
                ariaLabel={i18next.t(
                    'videoconference.remote_video.restart_video_connection',
                )}
                onClick={onRestart}
            >
                <Icon
                    iconKey="report_problem"
                    size={plateIconSize(isCompact)}
                />
            </LabelPlate>
        </Tooltip>
    );
};

export default RestartVideoPlate;
